var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          class: _vm.classes,
          style: _vm.stylesObject,
          attrs: {
            type: _vm.type,
            variant: _vm.variant,
            disabled: _vm.disabled,
            loading: _vm.loading
          }
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.loading
        ? _c(
            "span",
            { staticClass: "button__loading" },
            [_c("font-awesome-icon", { attrs: { icon: "spinner", spin: "" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "button__content" }, [
        _vm.icon
          ? _c(
              "span",
              { staticClass: "button__icon" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.icon, "fixed-width": "" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.containsContent
          ? _c("span", { staticClass: "button__text" }, [_vm._t("default")], 2)
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }